import { callZigzagFunction } from '../../callZigzagFunction';

// 상단 네비게이션 타이틀 변경
export const st = (title: string) => {
  callZigzagFunction('st')({ title });
};
